/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconArrowRight from '@telus-uds/palette-koodo/build/rn/icons/ArrowRight'
import PaletteIconArrowLeft from '@telus-uds/palette-koodo/build/rn/icons/ArrowLeft'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    nextIcon: PaletteIconArrowRight,
    previousIcon: PaletteIconArrowLeft
  }
}
export default theme
